import { useProducts } from "@sushicorp/contexts";
import { useFetchCategories } from "@sushicorp/services";
import { sanitizeQueryParams } from "@sushicorp/utils";
import { AdditionalInfo, Category } from "artisn/types";
import { useRouter } from "next/router";
import React from "react";
import { Link } from "react-scroll";

import CategoriesTabsMobilePlaceholder from "./CategoriesTabsMobile.placeholder";
import Styles from "./CategoriesTabsMobile.styles";
import { CategoriesTabsMobileProps as Props } from "./CategoriesTabsMobile.types";
import Button from "../Button/Button";
import { notify } from "utils/common.utils";

const CategoriesTabsMobile: React.FC<Props> = props => {
  const { className, onClickCategoryItem, withScrollTo } = props;
  const { data: categories, isLoading } = useFetchCategories(notify);
  const { setShowCategoryList } = useProducts();
  const { query } = useRouter();
  const { categoryId: categoryIdParam } = sanitizeQueryParams(query);

  /**
   * Execute in category event click.
   *
   * @since 1.0.0
   * @param {Category} category Category data.
   */
  const changeHandler = (category: Category) => {
    setShowCategoryList(false);
    setTimeout(() => {
      onClickCategoryItem(category);
    }, 100);
  };

  /**
   * Render category item component.
   *
   * @since 1.0.0
   * @param {Category<AdditionalInfo>} category Category data.
   */
  const renderCategoryItem = (category: Category<AdditionalInfo>) => {
    const { categoryId, name } = category;

    if (withScrollTo) {
      return (
        <Link
          key={categoryId}
          title={name}
          className="CategoriesTabsMobile__item"
          activeClass="CategoriesTabsMobile__item--active"
          to={`${categoryId}`}
          spy
          smooth
          offset={-280 + 116}
        >
          <div onClick={() => onClickCategoryItem?.(category)}>{name}</div>
        </Link>
      );
    }
    const buttonActive =
      categoryIdParam === `${categoryId}`
        ? "CategoriesTabsMobile__item--active"
        : "";

    return (
      <Button
        className={`CategoriesTabsMobile__item ${buttonActive}`}
        tabIndex={1}
        key={categoryId}
        onClick={() => changeHandler(category)}
      >
        <p className="CategoriesTabsMobile__item__text">{name}</p>
      </Button>
    );
  };

  if (!categories && !isLoading) return null;

  return (
    <Styles className={`CategoriesTabsMobile ${className}`}>
      {!isLoading && categories ? (
        <div className="CategoriesTabsMobile__tabs">
          {categories.map(category => {
            return renderCategoryItem(category);
          })}
        </div>
      ) : null}
      {isLoading ? <CategoriesTabsMobilePlaceholder /> : null}
    </Styles>
  );
};

CategoriesTabsMobile.defaultProps = {};

export default CategoriesTabsMobile;
